<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-31 10:39:38
 * @FilePath: /wemeet-admin-new/src/views/marketing/accDelivery.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="自定义群体投放" name="first">
        <vab-query-form>
          <vab-query-form-left-panel :span="12">
            <el-form :inline="true" :model="queryForm" @submit.prevent>
              <el-form-item label="群体名称">
                <el-input v-model.trim="queryForm.name" clearable placeholder="请输入群体名称" />
              </el-form-item>
              <el-form-item label="备注文字">
                <el-input v-model.trim="queryForm.remark" clearable placeholder="请输入备注文字" />
              </el-form-item>
              <el-form-item>
                <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
              </el-form-item>
            </el-form>
          </vab-query-form-left-panel>
          <vab-query-form-right-panel :span="12">
            <el-button type="primary" @click="importData($event)">批量导入</el-button>
            <el-button type="primary" @click="addGroupFunc($event)">筛选群体</el-button>
          </vab-query-form-right-panel>
        </vab-query-form>
        <el-table v-loading="listLoading" border :data="list">
          <el-table-column label="群体名称" prop="name" show-overflow-tooltip />
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
            <template #default="{ row }">
              <el-input v-if="row.showEdit" v-model="row.remark" @blur="saveRemark(row)" />
              <template v-else style="cursor: pointer">
                {{ row.remark ? row.remark : '暂无备注' }}
                <Edit style="width: 1em; height: 1em; margin-right: 8px" @click="row.showEdit = true" />
              </template>
            </template>
          </el-table-column>
          <el-table-column label="群体条件">
            <template #default="{ row }">
              <el-popover v-if="row.type && row.type.length > 0" placement="right" trigger="hover" :width="400">
                <template #reference>
                  <el-tag color="#00c4c9" style="cursor: pointer; color: #fff">查看条件明细</el-tag>
                </template>

                <ul class="ul">
                  <li v-for="(item, index) in row.type" :key="index">
                    {{ index + 1 }}.
                    <span style="margin: 0 5px">[报名展会]</span>
                    {{ item.valueName }}
                  </li>
                </ul>
              </el-popover>

              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column label="筛选人数">
            <template #default="{ row }">
              {{ row.userNum ? row.userNum : 0 }}
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip />
          <el-table-column label="操作" show-overflow-tooltip width="420">
            <template #default="{ row }">
              <el-button plain type="info" @click="handleSend(row)">投放</el-button>
              <el-button v-if="row.fileUrl" plain type="info" @click="handleShare(row)">下载</el-button>
              <!-- <el-button type="danger" plain @click="handleDelete(row)">
                删除
              </el-button> -->
            </template>
          </el-table-column>
          <template #empty>
            <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
            <el-empty class="vab-data-empty" description="暂无数据" />
          </template>
        </el-table>
        <el-pagination
          background
          :current-page="queryForm.pageNumber"
          :layout="layout"
          :page-size="queryForm.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />

        <addGroup ref="addgroupDrawer" @fetchData="queryData" />

        <VisitorImport ref="importRef" @fetchData="queryData" />

        <sendMessageVue ref="sendMessageRef" />
      </el-tab-pane>
      <el-tab-pane label="手机号投放" name="second">
        <phoneDelivery />
      </el-tab-pane>
      <el-tab-pane label="投放记录" name="third">
        <deliveryDetailVue ref="deliveryDetailRef" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search, Edit } from '@element-plus/icons'
  import { useRoute } from 'vue-router'
  import {
    getEnterpriseMarketingQueryDelivery,
    editEnterpriseMarketingUpdateDelivery,
    enterpriseMarketingDelDelivery,
  } from '@/api/exhibitionManage'
  import VisitorImport from './components/visitorImport.vue'
  import sendMessageVue from './components/sendMessage.vue'
  import phoneDelivery from './phoneDelivery.vue'
  import deliveryDetailVue from './deliveryDetail.vue'
  export default defineComponent({
    name: 'Brand',
    components: {
      addGroup: defineAsyncComponent(() => import('./components/addGroup')),
      VisitorImport,
      sendMessageVue,
      phoneDelivery,
      deliveryDetailVue,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          remark: '',
          pageNum: 1,
          pageSize: 10,
          name: '',
        },
        activeName: 'first',
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        addgroupDrawer: null,
        chooseVal: [],
        importRef: null,
        sendMessageRef: null,
        deliveryDetailRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            await enterpriseMarketingDelDelivery(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        state.queryForm.pageNum = 1
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getEnterpriseMarketingQueryDelivery(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      onActivated(() => {
        fetchData()
      })

      const addGroupFunc = () => {
        state.addgroupDrawer.handleOpen()
      }

      const handleSend = (row) => {
        state.sendMessageRef.handleOpen(row)
      }

      const handleSort = (row) => {
        state.editRef.showEdit(row)
      }
      const importBrand = () => {
        state.upLoadRef.showEdit()
      }
      const importProductBrand = () => {
        state.productUploadRef.showEdit()
      }
      const importResult = () => {
        state.resultRef.showEdit()
      }

      const handleShare = (row) => {
        if (row.fileUrl) {
          let xhr = new XMLHttpRequest()
          xhr.open('get', row.fileUrl, true)
          //  xhr.setRequestHeader('Content-Type', `application/${type}`);
          xhr.responseType = 'blob'
          xhr.onload = function () {
            if (this.status == 200) {
              //接受二进制文件流
              console.log(this)
              var blob = this.response
              const blobUrl = window.URL.createObjectURL(blob)
              // 这里的文件名根据实际情况从响应头或者url里获取
              const a = document.createElement('a')
              a.href = blobUrl
              a.download = row.name
              a.click()
              window.URL.revokeObjectURL(blobUrl)
            }
          }
          xhr.send()
        } else {
          proxy.$baseMessage(`当前无可下载文件`, 'error', 'vab-hey-message-error')
        }
      }

      const importData = () => {
        state.importRef.showEdit()
      }

      const saveRemark = async (row) => {
        console.log(row)
        try {
          let data = {
            id: row.id,
            remark: row.remark,
          }
          await editEnterpriseMarketingUpdateDelivery(data)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          fetchData()
        } catch (e) {
          console.log(e)
        }
      }

      const handleClick = (e) => {
        console.log(e, e.index)
        if (e.index == 0) {
          queryData()
        }
        if (e.index == 2) {
          state.deliveryDetailRef.queryData()
        }
      }
      return {
        ...toRefs(state),
        importData,
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        importProductBrand,
        handleConfig,
        Delete,
        Search,
        Plus,
        Edit,
        addGroupFunc,
        handleSort,
        handleSend,
        handleShare,
        importResult,
        importBrand,
        saveRemark,
        handleClick,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
